<template>
    <ResourceAttachSelect
        title="New Slides"
        label="Slides set"
        select-id="new_slides"
        type="slides"
        :options="slideOptions"
        @cancel="$emit('cancel')"
        @attach="$emit('attach', $event)"
    />
</template>

<script lang="ts">
import axios from "axios";
import ResourceAttachSelect from "./ResourceAttachSelect.vue";

export default {
    components: {
        ResourceAttachSelect,
    },
    props: {
        lessonId: {
            type: [String, Number],
            required: true,
        },
    },
    data(): any {
        return {
            slideOptions: [],
        };
    },
    methods: {
        async getSlideOptions() {
            try {
                const response = await axios.get(
                    "/api/learn/resources/slides/options"
                );

                this.slideOptions = response.data ?? [];
            } catch {
                this.slideOptions = [];
            }
        },
    },
    mounted() {
        this.getSlideOptions();
    },
};
</script>
